import React from 'react';
import Team from '../Data/Teams.json'; // ঠিক path

const Teams = () => {
  return (
    <div>
      {/* Hero Section =================*/}
      <div style={{ position: 'relative', width: '100%', height: '70vh' }}>
          <img
            src="/image/news1.jpg" alt="Hotel" className="img-fluid" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          
          {/* Black semi-transparent overlay */}
          <div style={{
            position: 'absolute',
            top: 0, left: 0,
            width: '100%', height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // 0.4 মানে হালকা কালো
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'white',
            fontSize: '3rem',
            fontWeight: 'bold'
          }}>
             Team Grid
          </div>
        </div>
         {/* Member section ================*/}
      <div style={{ background: "#f8f5f0" }}>
      <div className="container my-4 pt-5">
        <div className="row">
          <h1 className='pb-5'><u><i>Meet With Our Team Member</i></u></h1>
          {Team.map((item, index) => (
            <div key={index} className="col-lg-3 col-md-6 col-sm-12 mb-4">
             <div className="card d-flex flex-column" style={{ height: '250px' }}>
                <img
                  src={item.image}className="w-100 object-fit-cover"
                  style={{ height: '100%', display: 'block',border:'1px solid '}}
                  alt={item.title}
                />
                <div className="card-body p-2" style={{ height: '50%' }}>
                  <h5 className="card-title">{item.title}</h5>
                  <p className="card-text">{item.descrip}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    </div>
  );
}

export default Teams;
